// gkc_hash_code : 01GPFQ2BY4JCG0W281FKCRX39R

import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { mergeClasses } from 'util/commons';
import { Area, AreaGroup } from 'util/Types';

type SearchedAreaGroupProps = {
  areaGroup: AreaGroup;
  renderAreasList: (areas: Area[]) => React.ReactNode;
  sortAreas: (areas: Area[]) => Area[];
  handleUpdateRouteGroup: (
    groupId: string | undefined,
    replace?: boolean
  ) => void;
};

const SearchedAreaGroup: React.FC<SearchedAreaGroupProps> = ({
  areaGroup,
  renderAreasList,
  sortAreas,
  handleUpdateRouteGroup,
}) => {
  const [isShown, setIsShown] = useState(true);
  const { t } = useTranslation();

  if (!areaGroup.collectingRoutes?.length) {
    return null;
  }

  return (
    <div className="site-searched-group">
      <div className="site-searched-group-header">
        <p
          className="site-searched-group-title"
          onClick={() => handleUpdateRouteGroup(areaGroup.id)}
        >
          {areaGroup.name}
        </p>

        <p
          className={mergeClasses('site-searched-group-toggle', {
            'site-searched-group-toggle--active': isShown,
          })}
          onClick={() => setIsShown(!isShown)}
        >
          {isShown ? t('common.button.hide') : t('common.button.view')}
        </p>
      </div>

      {isShown && renderAreasList(sortAreas(areaGroup.collectingRoutes))}
    </div>
  );
};

export default SearchedAreaGroup;
